import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
   
    getdriverData: [],
    editdriverData: [],
    createdriverData: []
}

const DriverReducer = (state = initState, { type, payload }) => {

    
    switch (type) {
        case CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.GET_DRIVER_API_SUCCESS:
            return {
                ...state,
                getdriverData: payload.value
            }

        case CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.EDIT_DRIVER_API_SUCCESS:
            return {
                ...state,
                editdriverData: payload.value
            }

        case CONSTANTS.CONSTANTS_DRIVER_MANAGEMENT.ADD_DRIVER_API_SUCCESS:
            return {
                ...state,
                createdriverData: payload.value
            }

       

        default:
            return state
    }
}

export default DriverReducer;
